module.exports = __webpack_public_path__ + "static/logo_pointing_right-db2550a82be5c657f5aaed324cd0ef36.svg";